define('lq/runtimeDropPicker',[
    'when',
    './runtimeClone'
], function (when, RuntimeClone) {
    'use strict';

    var RuntimeDropPicker = function (action) {
        this.action = action;
        this.clone = null;
    };

    RuntimeDropPicker.prototype.canPick = function () {
        return !this.clone;
    };

    RuntimeDropPicker.prototype.pick = function () {
        return when.promise(this.createClone.bind(this));
    };

    RuntimeDropPicker.prototype.createClone = function (resolve) {
        var self = this;
        this.clone = new RuntimeClone({
            action: this.action,
            onSelect: function (rootMorphId, morphId) {
                resolve({
                    rootMorphId: rootMorphId,
                    morphId: morphId
                });
                self.destroyClone();
            },
            onCancel: function () {
                resolve(null);
                self.destroyClone();
            }
        });
        this.clone.create();    
    };

    RuntimeDropPicker.prototype.destroyClone = function () {
        this.clone.destroy();
        this.clone = null;
    };

    return RuntimeDropPicker;
});
